(() => {
  const target = document.querySelector('[data-sitemap-journal]');
  if (!target || target.dataset.loaded) return;
  target.dataset.loaded = 'true';
  const root = window.Shopify?.routes?.root || '/';
  const parse = async (path) => {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) return null;
    const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
    if (!response.ok) return null;
    return new DOMParser().parseFromString(await response.text(), 'application/xml');
  };
  const label = (slug) => decodeURIComponent(slug).replace(/[-_]+/g, ' ').replace(/^./u, (c) => c.toUpperCase());
  (async () => {
    const index = await parse(`${root}sitemap.xml`);
    if (!index) return;
    const articleMaps = [...index.querySelectorAll('sitemap > loc')].map((n) => n.textContent).filter((url) => /sitemap_(blogs|articles)_/.test(url) && new URL(url).pathname.startsWith(`${root}sitemap_`)).slice(0, 25);
    const links = new Map();
    for (const path of articleMaps) {
      const document = await parse(path);
      for (const loc of document?.querySelectorAll('url > loc') || []) {
        const url = new URL(loc.textContent);
        if (url.origin !== location.origin || !url.pathname.startsWith(`${root}blogs/`)) continue;
        const parts = url.pathname.split('/').filter(Boolean);
        const index = parts.indexOf('blogs');
        const title = loc.parentElement.getElementsByTagName('image:title')[0]?.textContent || label(parts.at(-1));
        links.set(url.pathname, { title, blog: label(parts[index + 1]) });
      }
    }
    const list = target.querySelector('ul');
    for (const [href, item] of [...links].sort((a, b) => a[1].title.localeCompare(b[1].title, 'fr'))) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = href;
      a.textContent = item.title;
      li.append(a);
      list.append(li);
    }
    target.hidden = links.size === 0;
  })().catch(() => {});
})();
